import React from 'react';

/** Generic fallback illustration — single page with a folded corner. */
const GenericPage = () => (
  <div className="ill-genpage" aria-hidden="true">
    <span className="ill-gen-corner"></span>
    <span className="ill-gen-bar"></span>
    <span className="ill-gen-bar ill-gen-bar-short"></span>
    <span className="ill-gen-bar"></span>
    <span className="ill-gen-bar"></span>
    <span className="ill-gen-bar ill-gen-bar-short"></span>
  </div>
);

export default GenericPage;
